/**
 * @generated SignedSource<<70e839591d72a2092ab941e68b997e84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BankTransactionDirection = "IN" | "OUT" | "%future added value";
export type BankTransactionGroup = "CUSTOMER_PAYMENTS" | "FINANCING" | "OTHER" | "SALARIES" | "SUPPLIERS" | "TAX_OFFICE" | "TRANSFER" | "%future added value";
export type BankTransactionRuleField = "COUNTERPARTY_NAME" | "PURPOSE" | "%future added value";
export type ConfigurationBankTransactionRulesViewQuery$variables = Record<PropertyKey, never>;
export type ConfigurationBankTransactionRulesViewQuery$data = {
  readonly bankTransactionRules: ReadonlyArray<{
    readonly containedText: string;
    readonly direction: BankTransactionDirection | null | undefined;
    readonly field: BankTransactionRuleField;
    readonly id: string;
    readonly position: number;
    readonly transactionGroup: BankTransactionGroup;
  }>;
};
export type ConfigurationBankTransactionRulesViewQuery = {
  response: ConfigurationBankTransactionRulesViewQuery$data;
  variables: ConfigurationBankTransactionRulesViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BankTransactionRule",
    "kind": "LinkedField",
    "name": "bankTransactionRules",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "field",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "containedText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "direction",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transactionGroup",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "position",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfigurationBankTransactionRulesViewQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ConfigurationBankTransactionRulesViewQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4c345e9fd0a4ff78da152dfb4cfd4d7d",
    "id": null,
    "metadata": {},
    "name": "ConfigurationBankTransactionRulesViewQuery",
    "operationKind": "query",
    "text": "query ConfigurationBankTransactionRulesViewQuery {\n  bankTransactionRules {\n    id\n    field\n    containedText\n    direction\n    transactionGroup\n    position\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc7001ec07e612d10c49f2a588948623";

export default node;
